$.fn.UpcomingSale = function() {
  let self = this
  self.timer = setInterval(runEveryMinute, 30000);
  self.id = self.attr('data-id')
  self.date = upcoming_urls[self.id][0]
  self.url = upcoming_urls[self.id][1]

  function runEveryMinute() {
    var timestampDate = new Date(parseInt(self.date) * 1000);
    var now = new Date();

    if (timestampDate < now) {
      self.next('.tickets__item__price').removeClass('--upcoming')
      self.next('.tickets__item__price').next('.--upcoming').find('.tickets__item__link').attr('href', self.url)
      self.next('.tickets__item__price').next('.--upcoming').removeClass('--upcoming')
      self.remove()
      clearInterval(self.timer);
    }
  }

  return function() {
    runEveryMinute();
    return self
  }()
}
